'use client';

import { useEffect, useState } from 'react';
import type SwiperRef from 'swiper';
// Import Swiper React components
import type { VideoInfo, VideoInfo_Tournament } from '@/apis/types/stepinContent';
import Icon from '@/Icon';
import { addLayer, deleteLayer, lazyDeleteLayer } from '@/legacy/components/apps/ClientModalProvider';
import Img from '@/legacy/components/img/FillImage';
import AppDownModal from '@/legacy/components/modalContents/AppDownModal';
import VideoModal from '@/legacy/components/modalContents/VideoModal';
import { useTranslations } from 'next-intl';
import { nullCashReplace } from '@/utilities/stateTool';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

const championListAtom = atom<VideoInfo[]>([]);

// Import Swiper styles
import { atom, useAtom, useAtomValue } from 'jotai';

import styles from '@/legacy/components/new/tournamentChampion.module.scss';
import 'swiper/css';
import { useTransTournament } from '@/@shared/hooks/useTranslations';

// Import domains API
import { useFetchVideoTournamentChampionWebQuery } from '@/domains/content/api/video/useVideoQueries';

type Props = {};

const VIDEO_MODAL_KEY = 'videoModal';

export const openVideoModal = (
	id: string,
	thumbnailUrl: string,
	index: number,
	onClick: (index: number) => void,
	tournament?: VideoInfo_Tournament
) => {
	lazyDeleteLayer(VIDEO_MODAL_KEY).then((e) => {
		addLayer(
			VIDEO_MODAL_KEY,
			<section className={styles.section}>
				<button className={styles.left} onClick={() => onClick(index - 1)}>
					<Icon path="Navi_Chevron_24_White_Left" />
				</button>

				<VideoModal id={id} thumbnailUrl={thumbnailUrl} tournament={tournament} />

				<button className={styles.right} onClick={() => onClick(index + 1)}>
					<Icon path="Navi_Chevron_24_White_Right" />
				</button>
			</section>,
			{
				escapeActive: true,
				freeze: true,
				outsideDismiss: true,
			}
		);
	});
};

const Page = ({ item, index, max }: { item: VideoInfo; index: number; max: number }) => {
	// item.tournament.isPrivate
	// item.organizer
	const thumbnailUrl = item.video.thumbnailUrl;
	const swiper = useSwiper();

	const onClick = useOnClick(max, swiper);

	return (
		<button
			className={styles.posterFrame}
			onClick={() => {
				openVideoModal(item.video.id, thumbnailUrl, index, onClick, item.tournament);
			}}
		>
			<Img className={styles.poster} src={nullCashReplace(thumbnailUrl)} />

			{/* {item.tournament.isPrivate && <Private className={styles.private}></Private>} */}
		</button>
	);
};
/**
 * STEPIN 앱 설치하기
 * @param title
 */
const openAppDownModal = (title: string) => {
	addLayer(
		'AppDownload',
		<AppDownModal
			closeFn={() => {
				deleteLayer('AppDownload');
			}}
			QRTopDescription
			titleComp={<span className={styles.modalTitle}>{title}</span>}
		/>,
		{
			freeze: true,
			outsideDismiss: true,
		}
	);
};

const useOnClick = (max: number, handler?: SwiperRef) => {
	const championList = useAtomValue(championListAtom);
	if (max === 0) {
		return (target: number) => {};
	}

	return function onClick(target: number) {
		const targetIndex = target % max;

		const lastIndex = targetIndex < 0 ? max - 1 : targetIndex;

		if (championList && handler) {
			const item = championList[lastIndex];

			const thumbnailUrl = item.video.thumbnailUrl;
			handler.slideToLoop(lastIndex);

			const tournament = item.tournament;

			openVideoModal(item.video.id, thumbnailUrl, lastIndex, onClick, tournament);
		}
	};
};

const TournamentChampion = () => {
	const t = useTransTournament('temp.home');

	const { data, error, isLoading } = useFetchVideoTournamentChampionWebQuery({});

	const [handler, setHandler] = useState<SwiperRef>();
	const [active, setActive] = useState(1);
	const [championList, setChampionList] = useAtom(championListAtom);

	const videoList = data?.data?.tournamentChampionVideoList || [];
	const max = videoList.length;

	useEffect(() => {
		if (videoList.length > 0) {
			setChampionList([...videoList]);
		}
	}, [videoList, setChampionList]);

	// 에러 상태 처리 - 조용히 숨김
	if (error) {
		return <></>;
	}

	// 빈 상태 처리
	if (championList && championList.length > 0) {
		return (
			<div className={styles.gallerySection}>
				<h2 className={styles.championTitle}>{t('tournamentChampion')}</h2>
				<span className={styles.championDescription}>{t('watchPopularWinners')}</span>
				<div className={styles.championSection}>
					<Swiper
						className="embla"
						initialSlide={3}
						loop={championList.length > 4}
						onSlideChange={(e) => {
							setActive(e.realIndex);
						}}
						onSwiper={setHandler}
						slidesPerView={4}
						spaceBetween={16}
						// breakpoints={{
						// 	1: {
						// 		slidesPerView: 2,
						// 	},
						// 	200: {
						// 		slidesPerView: 3,
						// 	},

						// 	384: {
						// 		slidesPerView: 3.5,
						// 	},

						// 	688: {
						// 		slidesPerView: 4,
						// 	},
						// 	1216: {
						// 		slidesPerView: 6,
						// 	},
						// }}
					>
						{[...championList].map((item, index) => {
							return (
								<SwiperSlide key={index}>
									<Page index={index} item={item} max={max} />
								</SwiperSlide>
							);
						})}
					</Swiper>
				</div>

				<button
					className={styles.viewMoreButton}
					onClick={(e) => {
						console.log('click', e);
						openAppDownModal(t('appInstall'));
					}}
				>
					{t('exploreApp')}
					<Icon className={styles.right} color1={'#FDFDFE'} path="Right" />
				</button>
			</div>
		);
	}

	return <></>;
};

export default TournamentChampion;
